<template>
    <div class="home-container">
      <div class="d-flex flex-column align-items-center justify-content-center gap-3">
        <h5 class="extra-large-text">დაამატეთ საარჩევნო უბანი</h5>
        <form class="add-form modal-form-grid-wrapper p-4 border-radius-10" @submit.prevent="addDistrict">
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="districtName" class="ms-2">უბნის სახელი(ქართულად)</label>
            <input v-model="districtDataVModels.district" pattern="[\u10A0-\u10FF\d !@#$^&\(\)\/*.+,_:?\-\\]+" type="text" autocomplete="off" name="districtName" id="districtName" required placeholder="უბნის სახელი(ქართულად)" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="districtengName" class="ms-2">(ინგლისურად)უბნის სახელი</label>
            <input v-model="districtDataVModels.districteng" pattern="[A-Za-z\d !@#$^&\(\)\/*.+,_:?\-\\]+" type="text" autocomplete="off" name="districtengName" id="districtengName" required placeholder="(ინგლისურად)უბნის სახელი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="districtengAddress" class="ms-2">უბნის მისამართი(ქართულად)</label>
            <input v-model="districtDataVModels.address" pattern="[\u10A0-\u10FF\d !@#$^&\(\)\/*.+,_:?\-\\]+" type="text" autocomplete="off" name="districtengAddress" id="districtengAddress" required placeholder="უბნის მისამართი(ქართულად)" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="districtengAddresseng" class="ms-2">(ინგლისურად)უბნის მისამართი</label>
            <input v-model="districtDataVModels.addresseng" pattern="[A-Za-z\d !@#$^&\(\)\/*.+,_:?\-\\]+" type="text" autocomplete="off" name="districtengAddresseng" id="districtengAddresseng" required placeholder="(ინგლისურად)უბნის მისამართი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="multiselects-wrapper d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <p class="ms-2">აირჩიეთ შემდეგი ველები</p>
            <linearSearchingMultiSearch :multiselectArray="multiselectArray" textSearchSendName="textSearch" dateInputSendName="dateSearch"
                :allowFiltersTitle="false" :allowExportButton="false" :allowTextSearch="false" :allowDateInput="false" @finalResult="getFinalResult"/>
          </fieldset>
          <div class="button-wrapper d-flex justify-content-center w-100">
            <secondaryButton :disabled="isSending" buttonWidth="max-content" buttonType="submit" class="large-text mt-4">
                <template v-slot:content>
                    დამატება
                </template>
            </secondaryButton>
          </div>
        </form>
        
        <div class="w-100">
            <polygonMapComponent maxHeight="700px" :allowedDrawingTools="['marker']" @updateMarker="updateMarker"/>
        </div>
      </div>
    </div>
</template>
<script>
import secondaryButton from "@/components/secondaryButton.vue"
import primaryButtonComponent from "@/components/primaryButtonComponent.vue";
import polygonMapComponent from "@/components/polygonMapComponent.vue";
import Multiselect from '@vueform/multiselect';
import linearSearchingMultiSearch from "@/components/linearSearchingMultiSearch.vue";
import { toRaw } from "vue";
export default {
  data(){
    return {
      districtDataVModels: {
        district: "",
        districteng: "",
        address: "",
        addresseng: "",
        regionID: null,
        lat: null,
        lng: null,
      },
      marker: null,
      multiselectArray: [
        {
          placeholder: "მუნიციპალიტეტი",
          getterEndpoint: "getMunicipalities",
          options: [],
          Vmodel: null,
          sendName: null,
          mode: "single",
          isDisabled: false,
          dependancyArray: [],
          previousMultiselectId: null,
          valueName: "municipalityID",
          georgianLabel: "municipality",
          englishLabel: "municipalityeng",
          locale: "ge",
        },
        {
          placeholder: "ქალაქი",
          getterEndpoint: "getCities",
          options: [],
          Vmodel: null,
          sendName: null,
          mode: "single",
          isDisabled: true,
          dependancyArray: [],
          previousMultiselectId: null,
          valueName: "cityID",
          georgianLabel: "city",
          englishLabel: "cityeng",
          locale: "ge",
        },
        {
          placeholder: "რაიონი",
          getterEndpoint: "getRegions",
          options: [],
          Vmodel: null,
          sendName: "regionID",
          mode: "single",
          isDisabled: true,
          dependancyArray: [],
          previousMultiselectId: null,
          valueName: "regionID",
          georgianLabel: "region",
          englishLabel: "regioneng",
          locale: "ge",
        },
      ],
      isSending: false,
    }
  },
  components: {
    secondaryButton,
    primaryButtonComponent,
    polygonMapComponent,
    Multiselect,
    linearSearchingMultiSearch,
  },
  mounted(){

  },
  methods: {
    updateMarker(newMarker){
      if(newMarker == null){
        this.districtDataVModels.lat = null;
        this.districtDataVModels.lng = null;
      }
      this.marker = toRaw(newMarker);
    },
    getFinalResult(finalResultObj){
      this.districtDataVModels[finalResultObj.sendName] = finalResultObj.value;
      
        // this.districtDataVModels.regionID = finalResult;
    },
    addDistrict(){
        let isdistrictValid = this.$helper.checkString(this.districtDataVModels.district);
        let isEngDistrictValid = this.$helper.checkEngString(this.districtDataVModels.districteng);
        let isdistrictAddressValid = this.$helper.checkString(this.districtDataVModels.address);
        let isEngDistrictAddressengValid = this.$helper.checkEngString(this.districtDataVModels.addresseng);

        let isRegionIDValid = this.$helper.checkNumber(this.districtDataVModels.regionID);
        this.districtDataVModels.lat = null;
        this.districtDataVModels.lng = null;

        
        if(this.marker != null){
          let markerPosition = toRaw(this.marker).getPosition();
          this.districtDataVModels.lat = markerPosition.lat();
          this.districtDataVModels.lng = markerPosition.lng();
        }

        if(isdistrictValid && isEngDistrictValid && isdistrictAddressValid && isEngDistrictAddressengValid && isRegionIDValid && this.districtDataVModels.lat){
          this.isSending = true;
            this.$store.dispatch("addDistrict", this.districtDataVModels).then((response) => {
            if(response.status == 201){
                this.$helper.showSwal("უბანი წარმატებით დაემატა", "success", "");
                setTimeout(() => {this.$router.go()}, 1500);
            }
            }).catch((error) => {
                if(error?.response?.status == 422){
                    this.$helper.showSwal("მოხდა შეცდომა", "error", "");
                    setTimeout(() => {this.$router.go()}, 1500);
                }
            }).finally(() => {
              this.isSending = false;
            })
        }
    }
  }
}
</script>
<style scoped>
input[type="checkbox"]{
    width: 30px;
    height: 30px;
    cursor: pointer;
}
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, min-content);
  row-gap: 1.5em;
}
.add-form{
  background-color: var(--secondary-background-color);
  width: 60%;
}
.modal-form-grid-wrapper{
  /* width: 100%; */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1em;
  row-gap: 2em;
}
.modal-form-grid-wrapper .blue-part-input{
  padding-block: 15px;
  max-width: 400px;
}
.button-wrapper, .multiselects-wrapper{
  grid-column: 1/3;
}
textarea.blue-part-input{
  width: 100%;
  resize: none;
}
.multiselect{
    --ms-placeholder-color: var(--light-blue);
    --ms-tag-bg: var(--light-blue);
    --ms-option-bg-selected: var(--light-blue);
    --ms-option-bg-selected-pointed: var(--light-blue);
    flex: 1;
    max-width: 235px;
    margin: 0;
}
#map{
    height: 500px;
    width: 100%;
}

@media screen and (max-width: 1800px) {
  .add-form{
    width: 70%;
  }
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 3em;
  }
}

@media screen and (max-width: 1560px) {
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 2em;
  }
  .modal-form-grid-wrapper .blue-part-input{
    padding: 10px;
  }
}
@media screen and (max-width: 1200px) {
  .add-form{
    width: 90%;
  }
}
</style>
